import { render, staticRenderFns } from "./Vagas_Areas.vue?vue&type=template&id=9d3375f2"
import script from "./Vagas_Areas.vue?vue&type=script&lang=js"
export * from "./Vagas_Areas.vue?vue&type=script&lang=js"
import style0 from "./Vagas_Areas.vue?vue&type=style&index=0&id=9d3375f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports